import { createAction, props } from '@ngrx/store';

export const requestNewConfigurationSearch = createAction('[Configuration Search] Start Configuration Search', props<{ filter: string }>());
export const resetConfigurationSearch = createAction('[Configuration Search] Reset Configuration Search');
